import {Component} from '@angular/core';

@Component({
  selector: 'app-error',
  standalone: true,
  templateUrl: './error.component.html'
})
export class ErrorComponent {
}
